import React from 'react';
import { HealthCategory } from './types';

// All health diary assets are served statically from the public folder.

// PNG icon paths - Health Categories (diary_general_logo)
const adlsIcon = '/health_diary/diary_general_logo/adls.png';
const inputIcon = '/health_diary/diary_general_logo/input.png';
const outputIcon = '/health_diary/diary_general_logo/output.png';
const emotionsIcon = '/health_diary/diary_general_logo/emotions.png';
const vitalIcon = '/health_diary/diary_general_logo/vital.png';
const gcsIcon = '/health_diary/diary_general_logo/gcs.png';
const painIcon = '/health_diary/diary_general_logo/pain.png';
const notesIcon = '/health_diary/diary_general_logo/notes.png';
const galleryIcon = '/health_diary/diary_general_logo/gallery.png';

// PNG icon paths - ADL Activities (ultimate_adl)
const activityIcon = '/health_diary/ultimate_adl/adl_new_activity.png';
const ambulationIcon = '/health_diary/ultimate_adl/adl_new_ambulation.png';
const bathingIcon = '/health_diary/ultimate_adl/adl_new_bathing.png';
const bedBathIcon = '/health_diary/ultimate_adl/adl_new_bedbath.png';
const changeClothesIcon = '/health_diary/ultimate_adl/adl_new_changeclothes.png';
const changeLinenIcon = '/health_diary/ultimate_adl/adl_new_changelinen.png';
const exerciseIcon = '/health_diary/ultimate_adl/adl_new_exercise.png';
const faceMassageIcon = '/health_diary/ultimate_adl/adl_new_facemassage.png';
const facialIcon = '/health_diary/ultimate_adl/adl_new_facial.png';
const feedFoodIcon = '/health_diary/ultimate_adl/adl_new_feedfood.png';
const haircutIcon = '/health_diary/ultimate_adl/adl_new_haircut.png';
const headMassageIcon = '/health_diary/ultimate_adl/adl_new_headmassage.png';
const bodyMassageIcon = '/health_diary/ultimate_adl/adl_new_massage.png';
const footMassageIcon = '/health_diary/ultimate_adl/adl_new_footmassage.png';
const nailcareIcon = '/health_diary/ultimate_adl/adl_new_nailcare.png';
const shavingIcon = '/health_diary/ultimate_adl/adl_new_shaving.png';
const toiletAssistIcon = '/health_diary/ultimate_adl/adl_new_toiletassist.png';
const turningIcon = '/health_diary/ultimate_adl/adl_new_turning.png';
const diaperChangeIcon = '/health_diary/ultimate_adl/adl_new_changediaper.png';
const applyLotionIcon = '/health_diary/ultimate_adl/adl_new_putlotion.png';
const lightStretchingIcon = '/health_diary/ultimate_adl/adl_new_lightstretching.png';

// PNG icon paths - Emotions (emoji)
const anxiousEmoji = '/health_diary/emoji/001-anxious.png';
const smiling = '/health_diary/emoji/022-smiling%20face.png';
const fallInLove = '/health_diary/emoji/021-fall-in-love.png';
const hug = '/health_diary/emoji/017-hug.png';
const vomiting = '/health_diary/emoji/008-vomiting.png';
const angry = '/health_diary/emoji/011-angry.png';
const angryVariant = '/health_diary/emoji/019-angry.png';
const thinking = '/health_diary/emoji/025-thinking.png';
const sleeping = '/health_diary/emoji/020-sleeping.png';
const tired = '/health_diary/emoji/026-tired.png';
const crying = '/health_diary/emoji/018-crying.png';

// PNG icon paths - GCS (gcs)
const eyeIcon = '/health_diary/gcs/eye.png';
const verbalIcon = '/health_diary/gcs/verbal.png';
const motorIcon = '/health_diary/gcs/motor.png';

// PNG icon paths - Bristol Stool Types (output_stool)
const type1Icon = '/health_diary/output_stool/type_1.png';
const type2Icon = '/health_diary/output_stool/type_2.png';
const type3Icon = '/health_diary/output_stool/type_3.png';
const type4Icon = '/health_diary/output_stool/type_4.png';
const type5Icon = '/health_diary/output_stool/type_5.png';
const type6Icon = '/health_diary/output_stool/type_6.png';
const type7Icon = '/health_diary/output_stool/type_7.png';

// PNG icon paths - Pain Levels (ultimate_pain)
const painLittle = '/health_diary/ultimate_pain/pain_little.png';
const painMild = '/health_diary/ultimate_pain/pain_mild.png';
const painModerate = '/health_diary/ultimate_pain/pain_moderate.png';
const painSevere = '/health_diary/ultimate_pain/pain_severe.png';
const painVerySevere = '/health_diary/ultimate_pain/pain_verysevere.png';
const painWorst = '/health_diary/ultimate_pain/pain_worst.png';

// PNG icon paths - IO Feeding Types (ultimate_io/feeding_type)
const feedingNormal = '/health_diary/ultimate_io/feeding_type/io_new_input_normal.png';
const feedingNGT = '/health_diary/ultimate_io/feeding_type/io_new_input_ngt.png';
const feedingPegTube = '/health_diary/ultimate_io/feeding_type/io_new_input_pegtube.png';

// PNG icon paths - IO Meal Categories (ultimate_io/meal_categories)
const mealBreakfast = '/health_diary/ultimate_io/meal_categories/io_new_input_breakfast.png';
const mealLunch = '/health_diary/ultimate_io/meal_categories/io_new_input_lunch.png';
const mealTeaTime = '/health_diary/ultimate_io/meal_categories/io_new_input_tea_time.png';
const mealDinner = '/health_diary/ultimate_io/meal_categories/io_new_input_dinner.png';
const mealFruits = '/health_diary/ultimate_io/meal_categories/io_new_input_fruits.png';
const mealSnack = '/health_diary/ultimate_io/meal_categories/io_new_input_snacks.png';

// PNG icon paths - IO Output Classifications (ultimate_io/io_classification)
const outputStool = '/health_diary/ultimate_io/io_classification/io_new_output_stool.png';
const outputUrine = '/health_diary/ultimate_io/io_classification/io_new_output_urine.png';

// PNG icon paths - IO Output Sub-Types (ultimate_io/output_type)
const outputTypeNormal = '/health_diary/ultimate_io/output_type/output_type_normal_toilet.png';
const outputTypeDiaper = '/health_diary/ultimate_io/output_type/output_type_diaper.png';
const outputTypeColostomy = '/health_diary/ultimate_io/output_type/output_type_colostomy.png';
const outputTypeIleostomy = '/health_diary/ultimate_io/output_type/output_type_ileostomy.png';

// PNG icon paths - Vitals (ultimate_diary_vitals)
const weightIcon = '/health_diary/ultimate_diary_vitals/weight.png';
const heartNew = '/health_diary/ultimate_diary_vitals/heart_new.png';
const bloodPressure = '/health_diary/ultimate_diary_vitals/bloodpressure.png';
const glucoseLevel = '/health_diary/ultimate_diary_vitals/glucoselevel.png';
const sleepIcon = '/health_diary/ultimate_diary_vitals/sleep.png';
const temperature = '/health_diary/ultimate_diary_vitals/temperature.png';
const sp02 = '/health_diary/ultimate_diary_vitals/sp02.png';
const respiration = '/health_diary/ultimate_diary_vitals/respiration.png';

// Icons for Important Info Card
export function AppointmentIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0h18M-4.5 12h22.5" />
        </svg>
    )
}

export function NoteIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
        </svg>
    )
}

export function ImportantNoteIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.562.562 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
        </svg>
    )
}

export function PhysioIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 4a1 1 0 100-2 1 1 0 000 2z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 21l-5-5-5 5" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 16V7" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M7 8l-4 4 4 4" />
        </svg>
    );
}

// Health categories with PNG icon strings
export const healthCategories = [
    { id: HealthCategory.ADL, icon: adlsIcon },
    { id: HealthCategory.INPUT, icon: inputIcon },
    { id: HealthCategory.OUTPUT, icon: outputIcon },
    { id: HealthCategory.EMOTIONS, icon: emotionsIcon },
    { id: HealthCategory.VITALS, icon: vitalIcon },
    { id: HealthCategory.GCS, icon: gcsIcon },
    { id: HealthCategory.PAIN, icon: painIcon },
    { id: HealthCategory.PHYSIO, icon: <PhysioIcon /> },
    { id: HealthCategory.NOTES, icon: notesIcon },
    { id: HealthCategory.IMPORTANT_NOTE, icon: <ImportantNoteIcon /> },
    { id: HealthCategory.PHOTOS, icon: galleryIcon },
] as const;

// ADL activities with PNG icon strings
export const adlActivities = [
  { label: 'Activity', icon: activityIcon },
  { label: 'Ambulation', icon: ambulationIcon },
  { label: 'Bathing', icon: bathingIcon },
  { label: 'Bed bath', icon: bedBathIcon },
  { label: 'Change Clothes', icon: changeClothesIcon },
  { label: 'Change Linen', icon: changeLinenIcon },
  { label: 'Exercise', icon: exerciseIcon },
  { label: 'Face Massage', icon: faceMassageIcon },
  { label: 'Facial', icon: facialIcon },
  { label: 'Feed Food', icon: feedFoodIcon },
  { label: 'Haircut', icon: haircutIcon },
  { label: 'Head Massage', icon: headMassageIcon },
  { label: 'Body Massage', icon: bodyMassageIcon },
  { label: 'Foot Massage', icon: footMassageIcon },
  { label: 'Nailcare', icon: nailcareIcon },
  { label: 'Shaving', icon: shavingIcon },
  { label: 'Toilet Assist', icon: toiletAssistIcon },
  { label: 'Turning', icon: turningIcon },
  { label: 'Diaper Change', icon: diaperChangeIcon },
  { label: 'Apply Lotion', icon: applyLotionIcon },
  { label: 'Light Stretching', icon: lightStretchingIcon },
];

export const ioCategories = [
  {
    title: 'Input',
    items: [
      { label: 'Oral Intake (Normal)', id: 'oral' },
      { label: 'Enteral Intake - NG Tube', id: 'ng_tube' },
      { label: 'Enteral Intake - PEG Tube', id: 'peg_tube' },
    ]
  },
  {
    title: 'Output',
    items: [
      { label: 'Stool', id: 'stool' },
      { label: 'Urinary', id: 'urinary' },
      { label: 'Vomitus', id: 'vomitus' },
    ]
  }
];

// Emotions with PNG emoji icon strings
export const emotions = [
    { label: 'Content', icon: smiling },
    { label: 'Playful', icon: hug },
    { label: 'Very Happy', icon: fallInLove },
    { label: 'Happy', icon: smiling },
    { label: 'Restless', icon: anxiousEmoji },
    { label: 'Sick', icon: vomiting },
    { label: 'Angry', icon: angry },
    { label: 'Annoyed', icon: angryVariant },
    { label: 'Confused', icon: thinking },
    { label: 'Sleepy', icon: sleeping },
    { label: 'Upset', icon: tired },
    { label: 'Sad', icon: crying },
];

// GCS categories with PNG icons
export const gcsCategories = {
  eye: {
    title: 'Eye Opening (E)',
    icon: eyeIcon,
    options: [
      { label: 'Spontaneous', score: 4 },
      { label: 'To sound (verbal command)', score: 3 },
      { label: 'To pain', score: 2 },
      { label: 'No response', score: 1 },
    ],
  },
  verbal: {
    title: 'Verbal Response (V)',
    icon: verbalIcon,
    options: [
      { label: 'Oriented to time, place, person', score: 5 },
      { label: 'Confused conversation, but able to answer', score: 4 },
      { label: 'Inappropriate words (random, unrelated)', score: 3 },
      { label: 'Incomprehensible sounds', score: 2 },
      { label: 'No response', score: 1 },
    ],
  },
  motor: {
    title: 'Motor Response (M)',
    icon: motorIcon,
    options: [
      { label: 'Obeys commands', score: 6 },
      { label: 'Localizes pain', score: 5 },
      { label: 'Withdraws from pain', score: 4 },
      { label: 'Abnormal flexion (decorticate posture)', score: 3 },
      { label: 'Abnormal extension (decerebrate posture)', score: 2 },
      { label: 'No response', score: 1 },
    ],
  },
};

export const physiotherapyActivities = [
  { label: 'Range of Motion', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 12c0-5.23-4.27-9.5-9.5-9.5S.5 6.77.5 12s4.27 9.5 9.5 9.5M12 2.5v19M12 2.5a9.5 9.5 0 00-9.486 9.5" /></svg> },
  { label: 'Strengthening', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18.5h12M12 2v5m0 10v5M5.636 5.636l1.414 1.414m10.304 10.304l-1.414-1.414M18.364 5.636l-1.414 1.414M6.05 18.364l1.414-1.414" /></svg> },
  { label: 'Balance Training', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 4a1 1 0 100-2 1 1 0 000 2z" /><path strokeLinecap="round" strokeLinejoin="round" d="M17 21l-5-5-5 5" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 16V7" /></svg> },
  { label: 'Gait Training', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M13 5a1 1 0 100-2 1 1 0 000 2z" /><path strokeLinecap="round" strokeLinejoin="round" d="M7 21l3-4" /><path strokeLinecap="round" strokeLinejoin="round" d="M16 21l-2-4-3-3 1-6" /><path strokeLinecap="round" strokeLinejoin="round" d="M6 12l2 3 4-1 3 3 3-2" /></svg> },
  { label: 'Manual Therapy', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9.75 17L3 10.25V5.5h4.75L14.25 12l-4.5 5z" /><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 5.5l-5.25 5.25" /></svg> },
  { label: 'Stretching', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 4a1 1 0 100-2 1 1 0 000 2zM4 12h16" /><path strokeLinecap="round" strokeLinejoin="round" d="M4 12l4 8h8l4-8" /></svg> },
  { label: 'Modalities', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3 12c3 4 9 4 12 0" /><path strokeLinecap="round" strokeLinejoin="round" d="M9 12c3 4 9 4 12 0" /></svg> },
  { label: 'Education', icon: <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6.252a5.485 5.485 0 013.36 9.392A5.5 5.5 0 0112 21.5a5.5 5.5 0 01-3.36-5.856A5.485 5.485 0 0112 6.252z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 4.5V2m0 19.5v-2.5" /></svg> },
];

export const weekdayAppointmentSlots = ['10:00 AM', '11:00 AM', '02:00 PM', '03:00 PM', '04:00 PM'];
export const weekendAppointmentSlots = ['10:00 AM', '11:00 AM', '02:00 PM', '03:00 PM'];

// Pain levels with PNG icons (promoted from local string array)
export const painLevels = [
  { label: 'Little', icon: painLittle },
  { label: 'Mild', icon: painMild },
  { label: 'Moderate', icon: painModerate },
  { label: 'Severe Pain', icon: painSevere },
  { label: 'Very Severe Pain', icon: painVerySevere },
  { label: 'Worst Possible', icon: painWorst },
];

// IO Constants - Feeding Types with PNG icons
export const feedingTypes = [
  { value: 1, label: 'Normal', icon: feedingNormal },
  { value: 2, label: 'NGT', icon: feedingNGT },
  { value: 3, label: 'Peg Tube', icon: feedingPegTube },
];

// IO Constants - Meal Categories with PNG icons
export const mealCategories = [
  { value: 1, label: 'Breakfast', icon: mealBreakfast },
  { value: 2, label: 'Lunch', icon: mealLunch },
  { value: 3, label: 'Tea Time', icon: mealTeaTime },
  { value: 4, label: 'Dinner', icon: mealDinner },
  { value: 5, label: 'Fruits', icon: mealFruits },
  { value: 6, label: 'Snack', icon: mealSnack },
];

export const unitCodes = [
  { value: 0, label: 'unit' },
  { value: 1, label: 'ml' },
  { value: 2, label: 'l' },
];

// IO Constants - Output Classifications with PNG icons
export const outputClassifications = [
  { value: 1, label: 'Stool', icon: outputStool },
  { value: 2, label: 'Urine', icon: outputUrine },
];

// IO Constants - Stool/Urine Output Types with optional PNG icons
export const stoolSubTypes = [
  { value: 1, label: 'Normal', icon: outputTypeNormal },
  { value: 2, label: 'Diaper', icon: outputTypeDiaper },
  { value: 3, label: 'Colostomy', icon: outputTypeColostomy },
  { value: 4, label: 'Ileostomy', icon: outputTypeIleostomy },
];

export const urineSubTypes = [
  { value: 1, label: 'Normal', icon: outputTypeNormal },
  { value: 2, label: 'Diaper', icon: outputTypeDiaper },
  { value: 3, label: 'CBD' },
  { value: 4, label: 'Urostomy' },
];

export const stoolColors = [
  { value: 1, label: 'Black', hex: '#000000' },
  { value: 2, label: 'Brown', hex: '#8B4513' },
  { value: 3, label: 'Light Brown', hex: '#D2A679' },
  { value: 4, label: 'Green', hex: '#228B22' },
  { value: 5, label: 'Red', hex: '#DC143C' },
  { value: 6, label: 'Pink/Purple', hex: '#9B59B6' },
  { value: 7, label: 'Grey', hex: '#808080' },
  { value: 8, label: 'Yellow', hex: '#FFD700' },
  { value: 9, label: 'Orange', hex: '#FF8C00' },
];

export const urineColors = [
  { value: 1, label: 'Clear', hex: '#F0F8FF' },
  { value: 2, label: 'Light Yellow', hex: '#FFFFE0' },
  { value: 3, label: 'Yellow', hex: '#FFD700' },
  { value: 4, label: 'Dark Yellow', hex: '#DAA520' },
  { value: 5, label: 'Amber', hex: '#FFBF00' },
  { value: 6, label: 'Brown', hex: '#8B4513' },
  { value: 7, label: 'Red', hex: '#DC143C' },
];

export const outputAmounts = [
  { value: 1, label: 'Large' },
  { value: 2, label: 'Moderate' },
  { value: 3, label: 'Small' },
];

// Bristol stool types with PNG icons
export const bristolStoolTypes = [
  { value: 1, label: 'Type 1', description: 'Separate hard lumps (hard to pass)', icon: type1Icon },
  { value: 2, label: 'Type 2', description: 'Lumpy, sausage-shaped', icon: type2Icon },
  { value: 3, label: 'Type 3', description: 'Sausage-shaped with cracks', icon: type3Icon },
  { value: 4, label: 'Type 4', description: 'Smooth, soft sausage or snake', icon: type4Icon },
  { value: 5, label: 'Type 5', description: 'Soft blobs with clear-cut edges', icon: type5Icon },
  { value: 6, label: 'Type 6', description: 'Fluffy, mushy pieces', icon: type6Icon },
  { value: 7, label: 'Type 7', description: 'Watery, no solid pieces', icon: type7Icon },
];

// Vital icons keyed by exact VITAL_VALIDATIONS label
export const vitalIcons: Record<string, string> = {
  'Weight (kg)': weightIcon,
  'Heart Rate (bpm)': heartNew,
  'BP Systolic': bloodPressure,
  'BP Diastolic': bloodPressure,
  'Glucose (mmol/L)': glucoseLevel,
  'Sleep (hrs)': sleepIcon,
  'Temp (°C)': temperature,
  'SpO2 (%)': sp02,
  'Respiration (bpm)': respiration,
};
